// import {
//   Grid,
// } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSButton from "../../../Components/Button/WSButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import {
//   callAPI,
//   getLocalValue,
//   LoacalVariables,
//   Method,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useForm } from "react-hook-form";

// export const LabReport: React.FC<any> = React.memo(() => {
//   const navigate = useNavigate();
//   const { control, setValue } = useForm();
//   const params = useParams();

//   const [labReports, setLabReports] = useState<any[]>([]);
//   const [filteredReports, setFilteredReports] = useState<any[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [labId, setLabId] = useState<string>("");
  
//   const filters = ["All", "Uploaded", "Not Uploaded"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   // ✅ FIXED: Proper TypeScript typing for filterCounts
//   const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
//     All: 0,
//     Uploaded: 0,
//     "Not Uploaded": 0,
//   });

//   // Header setup
//   useEffect(() => {
//     updateMainHeader("Report");
//     breadCrumbsStore.updateBreadCrumbs([{ Reports: "" }]);
//   }, []);

//   // Load labId
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     console.log("🚀 Lab ID loaded:", userId);
//     setLabId(userId || "");
//   }, []);

//   // Fetch lab reports
//   useEffect(() => {
//     const fetchLabReports = async () => {
//       if (!labId) {
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);
//         const response = await callAPI(
//           `lab/LabReport/${labId}`,
//           Method.GET,
//           null
//         );

//         if (response && Array.isArray(response)) {
//           const transformedData = response.map((item: any, index: number) => ({
//             id: item.bookingId || `report-${index}`,
//             ...item,
//             status: item.status,
//             reportUrl: item.reportUrl || "",
//             isReportUploaded: item.isReportUploaded || false,
//           }));
          
//           setLabReports(transformedData);
          
//           // ✅ Calculate initial filter counts
//           const counts: Record<string, number> = {
//             All: transformedData.length,
//             Uploaded: transformedData.filter((r: any) => r.isReportUploaded).length,
//             "Not Uploaded": transformedData.filter((r: any) => !r.isReportUploaded).length,
//           };
//           setFilterCounts(counts);
//           setFilteredReports(transformedData); // Default to All
//         }
//       } catch (error) {
//         console.error("Error fetching lab reports:", error);
//         setLabReports([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLabReports();
//   }, [labId]);

//   // ✅ PERFECT: handleFilterChange - Exactly like your example
//   const handleFilterChange = useCallback(
//     (value: string) => {
//       const originalFilter = value.replace(/\(\d+\)$/, "").trim();
//       console.log("🔄 Filter changed to:", originalFilter);
//       setSelectedFilter(originalFilter);

//       if (originalFilter === "All") {
//         setFilteredReports(labReports);
//       } else {
//         const filtered = labReports.filter((report) =>
//           originalFilter === "Uploaded"
//             ? report.isReportUploaded
//             : !report.isReportUploaded
//         );
//         setFilteredReports(filtered);
//       }
//     },
//     [labReports]
//   );

//   // ✅ PERFECT: getFilterLabel - Shows counts like "All(25)"
//   const getFilterLabel = useCallback(
//     (filter: string) => {
//       const count = filterCounts[filter] || 0;
//       return `${filter}(${count})`;
//     },
//     [filterCounts]
//   );

//   // Update filter counts when labReports changes
//   useEffect(() => {
//     const counts: Record<string, number> = {
//       All: labReports.length,
//       Uploaded: labReports.filter((r: any) => r.isReportUploaded).length,
//       "Not Uploaded": labReports.filter((r: any) => !r.isReportUploaded).length,
//     };
//     setFilterCounts(counts);
//   }, [labReports]);

//   const handleAction = async (action: string, row: any) => {
//     if (action === "View") {
//       navigate(`/labreport/view`, {
//         state: {
//           reportId: row?.id,
//           reportUrl: row?.reportUrl,
//         },
//       });
//     }
//   };

//   const columns: IColumns[] = [
//     { header: "Order ID", fieldName: "orderNo", type: "default" },
//     { header: "Sample Date", fieldName: "sampleDate", type: "date" },
//     { header: "Patient Name", fieldName: "patientName", type: "default" },
//     { header: "Test / Packages", fieldName: "testName", type: "default" },
//     {
//       header: "Report",
//       fieldName: "reportUrl",
//       type: "default",
//     },
//     { header: "Status", fieldName: "status", type: "status" },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Update", "View", "Download"],
//       actionCallback: (action, row) => handleAction(action, row),
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Test Name",
//       fieldName: "testName",
//       type: "dropdown",
//       options: [
//         { label: "CBC", value: "Complete Blood Count (CBC)" },
//         { label: "Chest X-Ray", value: "Chest X-Ray" },
//         { label: "Blood Test", value: "Blood Test" },
//       ],
//       operator: "like",
//       rowDivision: 3,
//     },
//     {
//       label: "Status",
//       fieldName: "status",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "" },
//         { label: "OrderPlaced", value: "OrderPlaced" },
//         { label: "Assigned", value: "Assigned" },
//         { label: "Report Generated", value: "Report Generated" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//     {
//       label: "By Date",
//       fieldName: "sampleDate",
//       type: "date",
//       operator: "like",
//       rowDivision: 6,
//     },
//   ];

//   const handleClick = () => {
//     navigate(`/lab-report/add`);
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid
//           item
//           sm={12}
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minHeight="400px"
//         >
//           <div>Loading lab reports...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today Orders"
//             value="40"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Uploaded Reports"
//             value={filterCounts.Uploaded.toString()}
//             percentage="+12%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Pending Uploads"
//             value={filterCounts["Not Uploaded"].toString()}
//             percentage="-8%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Reports"
//             value={filterCounts.All.toString()}
//             percentage="+5%"
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={9}>
//           {/* ✅ FIXED: Pass transformed options with counts */}
//           <WSFilterButtonGroup
//             options={filters.map(filter => getFilterLabel(filter))}
//             selected={getFilterLabel(selectedFilter)}
//             onChange={handleFilterChange}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           <WSDataGridNew
//             id="labReportGrid"
//             title={`Lab Reports (${filteredReports.length})`}
//             columns={columns}
//             data={filteredReports}
//             filterFields={filterRows}
//             exportCsv={true}
//             addButton={{ label: "New", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             searchBox={{ fieldNames: ["orderNo", "patientName", "testName"] }}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       </Grid>
//     </>
//   );
// });

// export default LabReport;




// import {
//   Grid,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Paper,
// } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSButton from "../../../Components/Button/WSButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import {
//   callAPI,
//   getLocalValue,
//   LoacalVariables,
//   Method,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useForm } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";

// // ✅ Status update payload interface
// interface UpdateStatusPayload {
//   bookingId: string;
//   status: string;
// }

// export const LabReport: React.FC<any> = React.memo(() => {
//   const navigate = useNavigate();
//   const { control, setValue } = useForm();
//   const params = useParams();

//   const [labReports, setLabReports] = useState<any[]>([]);
//   const [filteredReports, setFilteredReports] = useState<any[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [labId, setLabId] = useState<string>("");
  
//   const filters = ["All", "Uploaded", "Not Uploaded"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
//     All: 0,
//     Uploaded: 0,
//     "Not Uploaded": 0,
//   });

//   // ✅ EXACT same states as LabAssignOrder
//   const [apiLoading, setApiLoading] = useState<Set<string>>(new Set());
//   const [snackbar, setSnackbar] = useState<{
//     open: boolean;
//     message: string;
//     severity: "success" | "error" | "info";
//   }>({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // Header setup
//   useEffect(() => {
//     updateMainHeader("Report");
//     breadCrumbsStore.updateBreadCrumbs([{ Reports: "" }]);
//   }, []);

//   // Load labId
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     console.log("🚀 Lab ID loaded:", userId);
//     setLabId(userId || "");
//   }, []);

//   // ✅ Extract fetch logic to useCallback
//   const fetchLabReports = useCallback(async () => {
//     if (!labId) {
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await callAPI(
//         `lab/LabReport/${labId}`,
//         Method.GET,
//         null
//       );

//       if (response && Array.isArray(response)) {
//         const transformedData = response.map((item: any, index: number) => ({
//           id: item.bookingId || `report-${index}`,
//           backendBookingId: item.bookingId, // ✅ CRITICAL for status updates
//           ...item,
//           status: item.status || "Pending",
//           reportUrl: item.reportUrl || "",
//           isReportUploaded: item.isReportUploaded || false,
//           reportStatus: item.reportUrl ? "Available" : "N/A", // ✅ For display
//         }));
        
//         setLabReports(transformedData);
//         setFilteredReports(transformedData);
        
//         // Calculate filter counts
//         const counts: Record<string, number> = {
//           All: transformedData.length,
//           Uploaded: transformedData.filter((r: any) => r.isReportUploaded).length,
//           "Not Uploaded": transformedData.filter((r: any) => !r.isReportUploaded).length,
//         };
//         setFilterCounts(counts);
//       } else {
//         setLabReports([]);
//         setFilteredReports([]);
//       }
//     } catch (error) {
//       console.error("Error fetching lab reports:", error);
//       setLabReports([]);
//       setFilteredReports([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [labId]);

//   // Fetch reports when labId changes
//   useEffect(() => {
//     fetchLabReports();
//   }, [fetchLabReports]);

//   // ✅ FIXED #1: PERFECT Status Update - Updates IMMEDIATELY
//   const handleStatusUpdate = useCallback(async (backendBookingId: string, newStatus: string = "InProcess") => {
//     console.log("🔄 handleStatusUpdate called with:", backendBookingId, newStatus);

//     const currentReport = labReports.find(r => r.backendBookingId === backendBookingId);
//     if (!currentReport) {
//       setSnackbar({
//         open: true,
//         message: "Report not found",
//         severity: "error",
//       });
//       return;
//     }

//     if (currentReport.status?.toLowerCase() === newStatus.toLowerCase()) {
//       setSnackbar({
//         open: true,
//         message: `Report already ${newStatus}`,
//         severity: "info",
//       });
//       return;
//     }

//     setApiLoading((prev) => {
//       const s = new Set(prev);
//       s.add(backendBookingId);
//       return s;
//     });

//     try {
//       const payload: UpdateStatusPayload = {
//         bookingId: backendBookingId,
//         status: newStatus
//       };

//       console.log("📤 Status update payload:", payload);

//       const response: any = await http.put("lab/LabBooking/update-status", payload);
//       console.log("📥 RAW API RESPONSE:", response);

//       if (response?.success === false || !response?.success) {
//         const errorMsg = response?.message || response?.data?.message || "API failed";
//         throw new Error(errorMsg);
//       }

//       // ✅ FIXED: Update BOTH states IMMEDIATELY for instant grid refresh
//       const updatedReports = labReports.map(report => 
//         report.backendBookingId === backendBookingId
//           ? { ...report, status: newStatus }
//           : report
//       );
      
//       setLabReports(updatedReports);
//       setFilteredReports(updatedReports); // ✅ THIS makes grid update instantly!

//       setSnackbar({
//         open: true,
//         message: `Status updated to ${newStatus} successfully ✅`,
//         severity: "success",
//       });

//     } catch (error: any) {
//       console.error("❌ Status Update Error:", error);
      
//       let errorMsg = "Failed to update status";
//       if (error?.response?.data?.message) {
//         errorMsg = error.response.data.message;
//       } else if (error?.message) {
//         errorMsg = error.message;
//       }
      
//       setSnackbar({ 
//         open: true, 
//         message: errorMsg, 
//         severity: "error" 
//       });
//     } finally {
//       setApiLoading((prev) => {
//         const s = new Set(prev);
//         s.delete(backendBookingId);
//         return s;
//       });
//     }
//   }, [labId, labReports]); // ✅ Dependencies fixed

//   // ✅ FIXED #2: Sync filteredReports when labReports changes
//   useEffect(() => {
//     if (selectedFilter === "All") {
//       setFilteredReports(labReports);
//     }
//   }, [labReports, selectedFilter]);

//   // ✅ FIXED #3: Filter change always uses latest data
//   const handleFilterChange = useCallback(
//     (value: string) => {
//       const originalFilter = value.replace(/\(\d+\)$/, "").trim();
//       console.log("🔄 Filter changed to:", originalFilter);
//       setSelectedFilter(originalFilter);

//       if (originalFilter === "All") {
//         setFilteredReports(labReports);
//       } else {
//         const filtered = labReports.filter((report) =>
//           originalFilter === "Uploaded"
//             ? report.isReportUploaded
//             : !report.isReportUploaded
//         );
//         setFilteredReports(filtered);
//       }
//     },
//     [labReports] // ✅ Always uses latest labReports
//   );

//   const getFilterLabel = useCallback(
//     (filter: string) => {
//       const count = filterCounts[filter] || 0;
//       return `${filter}(${count})`;
//     },
//     [filterCounts]
//   );

//   // Update filter counts when labReports changes
//   useEffect(() => {
//     const counts: Record<string, number> = {
//       All: labReports.length,
//       Uploaded: labReports.filter((r: any) => r.isReportUploaded).length,
//       "Not Uploaded": labReports.filter((r: any) => !r.isReportUploaded).length,
//     };
//     setFilterCounts(counts);
//   }, [labReports]);

//   const handleAction = async (action: string, row: any) => {
//     console.log("Action:", action, "Row ID:", row.backendBookingId);
    
//     switch(action) {
//       case "In Process":
//         await handleStatusUpdate(row.backendBookingId || row.id, "InProcess");
//         break;
//       // case "Update":
//       //   navigate(`/lab-report/add?bookingId=${row.backendBookingId}`);
//       //   break;
//       case "View":
//         navigate(`/labreport/view`, {
//           state: {
//             reportId: row?.id,
//             reportUrl: row?.reportUrl,
//             bookingId: row?.backendBookingId,
//           },
//         });
//         break;
//       case "Download":
//         if (row.reportUrl) {
//           window.open(row.reportUrl, '_blank');
//         } else {
//           setSnackbar({
//             open: true,
//             message: "No report available for download",
//             severity: "info",
//           });
//         }
//         break;
//     }
//   };

//   const columns: IColumns[] = [
//     { header: "Order ID", fieldName: "orderNo", type: "default" },
//     { header: "Sample Date", fieldName: "sampleDate", type: "date" },
//     { header: "Patient Name", fieldName: "patientName", type: "default" },
//     { header: "Test / Packages", fieldName: "testName", type: "default" },
//     { 
//       header: "Report", 
//       fieldName: "reportStatus",
//       type: "default" 
//     },
//     { header: "Status", fieldName: "status", type: "status" },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["In Process", "View", "Download"],
//       actionCallback: (action, row) => handleAction(action, row),
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Test Name",
//       fieldName: "testName",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "" },
//         { label: "CBC", value: "Complete Blood Count (CBC)" },
//         { label: "Chest X-Ray", value: "Chest X-Ray" },
//         { label: "Blood Test", value: "Blood Test" },
//       ],
//       operator: "like",
//       rowDivision: 3,
//     },
//     {
//       label: "Status",
//       fieldName: "status",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "" },
//         { label: "OrderPlaced", value: "OrderPlaced" },
//         { label: "Assigned", value: "Assigned" },
//         { label: "InProcess", value: "InProcess" },
//         { label: "Report Generated", value: "Report Generated" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//     {
//       label: "By Date",
//       fieldName: "sampleDate",
//       type: "date",
//       operator: "gte",
//       rowDivision: 6,
//     },
//   ];

//   const handleClick = () => {
//     navigate(`/lab-report/add`);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ open: false, message: "", severity: "success" });
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid
//           item
//           sm={12}
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minHeight="400px"
//         >
//           <CircularProgress />
//           <div style={{ marginLeft: 16 }}>Loading lab reports...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       {/* Dashboard Cards */}
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today Orders"
//             value={filterCounts.All.toString()}
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Uploaded Reports"
//             value={filterCounts.Uploaded.toString()}
//             percentage="+12%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Pending Uploads"
//             value={filterCounts["Not Uploaded"].toString()}
//             percentage="-8%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Reports"
//             value={filterCounts.All.toString()}
//             percentage="+5%"
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters.map(filter => getFilterLabel(filter))}
//             selected={getFilterLabel(selectedFilter)}
//             onChange={handleFilterChange}
//           />
//         </Grid>
//       </Grid>

//       {/* Data Grid */}
//       <Paper sx={{ mt: 3, p: 3 }}>
//         <WSDataGridNew
//           id="labReportGrid"
//           title={`Lab Reports (${filteredReports.length})`}
//           columns={columns}
//           data={filteredReports}
//           filterFields={filterRows}
//           exportCsv={true}
//           addButton={{ label: "New Report", color: "secondary" }}
//           onAddButtonClick={handleClick}
//           searchBox={{ fieldNames: ["orderNo", "patientName", "testName"] }}
//           gridHeaderSx={{
//             backgroundColor: "whitesmoke",
//             border: "1px solid whitesmoke",
//           }}
//         />
//       </Paper>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// });

// export default LabReport;



import {
  Grid,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../../Components/Button/WSButton";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useForm } from "react-hook-form";
import http from "../../../commonFunctions/httpClient";
import configData from '../../../Config/config.json'; 

// ✅ Status update payload interface
interface UpdateStatusPayload {
  bookingId: string;
  status: string;
}

export const LabReport: React.FC<any> = React.memo(() => {
  const navigate = useNavigate();
  const { control, setValue } = useForm();
  const params = useParams();

  const [labReports, setLabReports] = useState<any[]>([]);
  const [filteredReports, setFilteredReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [labId, setLabId] = useState<string>("");
  
  const filters = ["All", "Uploaded", "Not Uploaded"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
   const imgUrl = configData.imgUrl;

  const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
    All: 0,
    Uploaded: 0,
    "Not Uploaded": 0,
  });

  // ✅ EXACT same states as LabAssignOrder
  const [apiLoading, setApiLoading] = useState<Set<string>>(new Set());
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  // Header setup
  useEffect(() => {
    updateMainHeader("Report");
    breadCrumbsStore.updateBreadCrumbs([{ Reports: "" }]);
  }, []);

  // Load labId
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🚀 Lab ID loaded:", userId);
    setLabId(userId || "");
  }, []);

  // ✅ Extract fetch logic to useCallback
  const fetchLabReports = useCallback(async () => {
    if (!labId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await callAPI(
        `lab/LabReport/${labId}`,
        Method.GET,
        null
      );
      console.log("response is ",response)

      if (response && Array.isArray(response)) {
        const transformedData = response.map((item: any, index: number) => ({
          id: item.bookingId || `report-${index}`,
          backendBookingId: item.bookingId, // ✅ CRITICAL for status updates
          ...item,
          status: item.status || "Pending",
          reportUrl: item.reportUrl || "",
          isReportUploaded: item.isReportUploaded || false,
          reportStatus: item.reportUrl ? "Available" : "N/A", // ✅ For display
        }));
        
        setLabReports(transformedData);
        setFilteredReports(transformedData);
        
        // Calculate filter counts
        const counts: Record<string, number> = {
          All: transformedData.length,
          Uploaded: transformedData.filter((r: any) => r.isReportUploaded).length,
          "Not Uploaded": transformedData.filter((r: any) => !r.isReportUploaded).length,
        };
        setFilterCounts(counts);
      } else {
        setLabReports([]);
        setFilteredReports([]);
      }
    } catch (error) {
      console.error("Error fetching lab reports:", error);
      setLabReports([]);
      setFilteredReports([]);
    } finally {
      setLoading(false);
    }
  }, [labId]);

  // Fetch reports when labId changes
  useEffect(() => {
    fetchLabReports();
  }, [fetchLabReports]);

  // ✅ FIXED #1: PERFECT Status Update - Updates IMMEDIATELY
  const handleStatusUpdate = useCallback(async (backendBookingId: string, newStatus: string = "InProcess") => {
    console.log("🔄 handleStatusUpdate called with:", backendBookingId, newStatus);

    const currentReport = labReports.find(r => r.backendBookingId === backendBookingId);
    if (!currentReport) {
      setSnackbar({
        open: true,
        message: "Report not found",
        severity: "error",
      });
      return;
    }

    if (currentReport.status?.toLowerCase() === newStatus.toLowerCase()) {
      setSnackbar({
        open: true,
        message: `Report already ${newStatus}`,
        severity: "info",
      });
      return;
    }

    setApiLoading((prev) => {
      const s = new Set(prev);
      s.add(backendBookingId);
      return s;
    });

    try {
      const payload: UpdateStatusPayload = {
        bookingId: backendBookingId,
        status: newStatus
      };

      console.log("📤 Status update payload:", payload);

      const response: any = await http.put("lab/LabBooking/update-status", payload);
      console.log("📥 RAW API RESPONSE:", response);

      if (response?.success === false || !response?.success) {
        const errorMsg = response?.message || response?.data?.message || "API failed";
        throw new Error(errorMsg);
      }

      // ✅ FIXED: Update BOTH states IMMEDIATELY for instant grid refresh
      const updatedReports = labReports.map(report => 
        report.backendBookingId === backendBookingId
          ? { ...report, status: newStatus }
          : report
      );
      
      setLabReports(updatedReports);
      setFilteredReports(updatedReports); // ✅ THIS makes grid update instantly!

      setSnackbar({
        open: true,
        message: `Status updated to ${newStatus} successfully ✅`,
        severity: "success",
      });

    } catch (error: any) {
      console.error("❌ Status Update Error:", error);
      
      let errorMsg = "Failed to update status";
      if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error?.message) {
        errorMsg = error.message;
      }
      
      setSnackbar({ 
        open: true, 
        message: errorMsg, 
        severity: "error" 
      });
    } finally {
      setApiLoading((prev) => {
        const s = new Set(prev);
        s.delete(backendBookingId);
        return s;
      });
    }
  }, [labId, labReports]); // ✅ Dependencies fixed

  // ✅ FIXED #2: Sync filteredReports when labReports changes
  useEffect(() => {
    if (selectedFilter === "All") {
      setFilteredReports(labReports);
    }
  }, [labReports, selectedFilter]);

  // ✅ FIXED #3: Filter change always uses latest data
  const handleFilterChange = useCallback(
    (value: string) => {
      const originalFilter = value.replace(/\(\d+\)$/, "").trim();
      console.log("🔄 Filter changed to:", originalFilter);
      setSelectedFilter(originalFilter);

      if (originalFilter === "All") {
        setFilteredReports(labReports);
      } else {
        const filtered = labReports.filter((report) =>
          originalFilter === "Uploaded"
            ? report.isReportUploaded
            : !report.isReportUploaded
        );
        setFilteredReports(filtered);
      }
    },
    [labReports] // ✅ Always uses latest labReports
  );

  const getFilterLabel = useCallback(
    (filter: string) => {
      const count = filterCounts[filter] || 0;
      return `${filter}(${count})`;
    },
    [filterCounts]
  );

  // Update filter counts when labReports changes
  useEffect(() => {
    const counts: Record<string, number> = {
      All: labReports.length,
      Uploaded: labReports.filter((r: any) => r.isReportUploaded).length,
      "Not Uploaded": labReports.filter((r: any) => !r.isReportUploaded).length,
    };
    setFilterCounts(counts);
  }, [labReports]);

  const handleAction = async (action: string, row: any) => {
  console.log("🎯 Action:", action, "Row:", row);
  console.log("📁 imgUrl:", imgUrl);
  console.log("🔗 reportUrl:", row.reportUrl);

  switch(action) {
    case "In Process":
      await handleStatusUpdate(row.backendBookingId || row.id, "InProcess");
      break;
      
    case "View":
    case "Download":
      if (row.reportUrl) {
        // ✅ FIX 1: Remove UploadedImages/, use imgUrl (already has /Upload)
        const filename = row.reportUrl.replace(/^UploadedImages\//, '');
        
        // ✅ FIX 2: Use your configData.imgUrl!
        const pdfUrl = `${imgUrl}/${filename}`;
        
        console.log("📄 Opening PDF:", pdfUrl);
        
        const newWindow = window.open(pdfUrl, '_blank', 'noopener,noreferrer');
        
        if (!newWindow) {
          setSnackbar({
            open: true,
            message: "Please allow popups to view report",
            severity: "info",
          });
        }
      } else {
        setSnackbar({
          open: true,
          message: "No report available",
          severity: "info",
        });
      }
      break;
  }
};





  const columns: IColumns[] = [
    { header: "Order ID", fieldName: "orderNo", type: "default" },
    { header: "Sample Date", fieldName: "sampleDate", type: "date" },
    { header: "Patient Name", fieldName: "patientName", type: "default" },
    { header: "Test / Packages", fieldName: "testName", type: "default" },
    { 
      header: "Report", 
      fieldName: "reportStatus",
      type: "default" 
    },
    { header: "Status", fieldName: "status", type: "status" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["In Process", "View", "Download"],
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Test Name",
      fieldName: "testName",
      type: "dropdown",
      options: [
        { label: "All", value: "" },
        { label: "CBC", value: "Complete Blood Count (CBC)" },
        { label: "Chest X-Ray", value: "Chest X-Ray" },
        { label: "Blood Test", value: "Blood Test" },
      ],
      operator: "like",
      rowDivision: 3,
    },
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        { label: "All", value: "" },
        { label: "OrderPlaced", value: "OrderPlaced" },
        { label: "Assigned", value: "Assigned" },
        { label: "InProcess", value: "InProcess" },
        { label: "Report Generated", value: "Report Generated" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
    {
      label: "By Date",
      fieldName: "sampleDate",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
  ];

  const handleClick = () => {
    navigate(`/lab-report/add`);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ open: false, message: "", severity: "success" });
  };

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid
          item
          sm={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <CircularProgress />
          <div style={{ marginLeft: 16 }}>Loading lab reports...</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {/* Dashboard Cards */}
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Today Orders"
            value={filterCounts.All.toString()}
            percentage="+2.5%"
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Uploaded Reports"
            value={filterCounts.Uploaded.toString()}
            percentage="+12%"
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Pending Uploads"
            value={filterCounts["Not Uploaded"].toString()}
            percentage="-8%"
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Total Reports"
            value={filterCounts.All.toString()}
            percentage="+5%"
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
          />
        </Grid>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters.map(filter => getFilterLabel(filter))}
            selected={getFilterLabel(selectedFilter)}
            onChange={handleFilterChange}
          />
        </Grid>
      </Grid>

      {/* Data Grid (WSDataGridNew already renders its own Paper, so no extra wrapper) */}
      <Box sx={{ mt: 3 }}>
        <WSDataGridNew
          id="labReportGrid"
          title={`Lab Reports (${filteredReports.length})`}
          columns={columns}
          data={filteredReports}
          filterFields={filterRows}
          exportCsv={true}
          addButton={{ label: "New Report", color: "secondary" }}
          onAddButtonClick={handleClick}
          searchBox={{ fieldNames: ["orderNo", "patientName", "testName"] }}
          gridHeaderSx={{
            backgroundColor: "whitesmoke",
            border: "1px solid whitesmoke",
          }}
        />
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default LabReport;
